import { Box, Grid, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useLessonPlanDetail } from '../../use-lesson-plan-detail-context'

type Props = {}

const Text = styled(Typography)`
  overflow-wrap: break-word;
  white-space: pre-wrap;
`

export const SchoolBackgroundTab = observer<Props>(() => {
  const { t } = useTranslation()
  const { lessonPlan } = useLessonPlanDetail()

  const displaySchoolBackground = useMemo(
    () =>
      lessonPlan.schoolBackgroundInformation?.length === 0 ||
      lessonPlan.schoolBackgroundInformation == null
        ? '---'
        : lessonPlan.schoolBackgroundInformation,
    [lessonPlan.schoolBackgroundInformation],
  )

  return (
    <Box>
      <Grid container justifyContent="flex-end" columnSpacing={3}>
        <Grid item mr="auto">
          <Typography fontWeight={600}>
            {t('lessonPlan.detail.general.menuTab.schoolBackground')}
          </Typography>
        </Grid>
      </Grid>
      <Box mt={5}>
        <Text>{displaySchoolBackground}</Text>
      </Box>
    </Box>
  )
})
